import { StorageService } from './services/storage.service';
// import { ElectronUpdaterService } from './services/electron-updater.service';
// import { ElectronLoggerService } from './services/electron-logger.service';
import { RedirectService } from './services/redirect.service';
import { Router } from '@angular/router';
import { WebService } from './services/web.service';
import { SessionService } from './services/session.service';
import { Component } from '@angular/core';

import { Platform, MenuController, NavController, AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from './services/utils.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Component(
	{
		selector: 'app-root',
		templateUrl: 'app.component.html'
	})
export class AppComponent {
	constructor(
		private Platform: Platform,
		private TranslateService: TranslateService,
		private SessionService: SessionService,
		private MenuController: MenuController,
		private WebService: WebService,
		// private ElectronUpdaterService: ElectronUpdaterService,
		// private ElectronLoggerService: ElectronLoggerService,
		private UtilsService: UtilsService,
		private RedirectService: RedirectService,
		private NavController: NavController,
		private StorageService: StorageService,
		private Router: Router,
		private swUpdate: SwUpdate,
		private alertController: AlertController) {
		//DISABLE MENU ATE HAVER UMA SESSAO VALIDA
		this.MenuController.enable(false);

		//GUARDA PATH DE ENTRADA NA APLICACAO PARA FUTURO REDIRECT SE NECESSARIO
		this.RedirectService.Set(window.location.pathname + window.location.search);

		this.Platform.ready().then(async () => {
			//INIT DO WEBSERVICE
			this.WebService.Init();

			// //INIT LOGGER SERVICES
			// ElectronLoggerService.Init();

			// //INIT UPDATER ELECTRON SERVICE
			// ElectronUpdaterService.Init();

			await this.StorageService.Init();

			this.TranslateService.addLangs(['pt-pt']);

			this.TranslateService.setDefaultLang('pt-pt');

			this.TranslateService.use('pt-pt');

			this.getTranslations();

			const session = await this.SessionService.Init()
			// console.log("SessionService Init : ", session);

			//APOS OBTER A SESSAO ACTUAL ATRIBUI TOKEN NO WS
			if (session && session.AccessToken)
				this.WebService.SetAuthorization(session.AccessToken);

			this.NavController.navigateRoot("/", { animated: false });

			// @claude Deteta novas versões deployed e notifica o utilizador para recarregar
			if (this.swUpdate.isEnabled) {
				this.swUpdate.versionUpdates.pipe(
					filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
				).subscribe(() => {
					this.showWebUpdateAlert();
				});
			}
		});
	}

	/** @claude Alerta de nova versão disponível — sem opção de dispensar para garantir que o utilizador atualiza */
	private async showWebUpdateAlert(): Promise<void> {
		const alert = await this.alertController.create({
			header: this.UtilsService.TranslateResource('VERSION_WEB_UPDATE_TITLE'),
			message: this.UtilsService.TranslateResource('VERSION_WEB_UPDATE_MESSAGE'),
			cssClass: 'custom-alert',
			buttons: [
				{ text: this.UtilsService.TranslateResource('TEXT_NOT_NOW'), role: 'cancel' },
				{
					text: this.UtilsService.TranslateResource('VERSION_UPDATE_BUTTON'),
					handler: () => {
						this.swUpdate.activateUpdate().then(() => document.location.reload());
					}
				}
			]
		});
		await alert.present();
	}

	private getTranslations(lang?: string) {

		lang = lang ? lang : this.TranslateService.getDefaultLang();

		const l = lang.split("-")[0];

		return this.WebService.GetTranslations(l).then((obj: string) => {

			if (obj) {
				const o = JSON.parse(obj) || {};
				this.UtilsService.AddResources(lang, o);
			}
		})
	}
}
